import {
  RecurrenceEndCondition,
  RecurrenceSchedule,
  RecurrenceScheduleDateStatus,
  RecurrenceScheduleFrequency
} from "@wingspanhq/wingspan-api-sdk";
import { Intervals } from "@wingspanhq/payments/dist/interfaces";
import { convertLocalDateToUTCDay } from "../../utils/dates";
import { FrequencyValues } from "../components/InvoicesForm/FrequencySection";

export const selectorRecurrenceSchedule = (request: {
  recurring: boolean;
  frequency: FrequencyValues;
  sendDate: Date;
}): RecurrenceSchedule => {
  if (!request.recurring) {
    return {
      scheduleDates: [
        {
          date: convertLocalDateToUTCDay(request.sendDate),
          status: RecurrenceScheduleDateStatus.PENDING
        }
      ]
    };
  }

  const startDate = convertLocalDateToUTCDay(
    request.frequency.start === "custom" && request.frequency.startDate
      ? new Date(request.frequency.startDate)
      : request.sendDate
  );

  return {
    frequency:
      request.frequency.interval === Intervals.Month
        ? RecurrenceScheduleFrequency.MONTHLY
        : RecurrenceScheduleFrequency.WEEKLY,
    interval: request.frequency.every || 1,
    anchorDate: startDate,
    endCondition: endCondition(request.frequency)
  };
};

const endCondition = (
  frequency: FrequencyValues
): RecurrenceSchedule["endCondition"] => {
  if (frequency.end === "date" && frequency.endDate) {
    return {
      type: "OnDate",
      endDate: convertLocalDateToUTCDay(new Date(frequency.endDate))
    } as unknown as RecurrenceEndCondition;
  }

  if (frequency.end === "after" && frequency.endAfter) {
    return {
      type: "AfterOccurrences",
      maxOccurrences: frequency.endAfter
    } as unknown as RecurrenceEndCondition;
  }

  return { type: "Never" } as unknown as RecurrenceEndCondition;
};
